import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { RtrButtonComponent } from '@rtr-factory/ui/button';
import { DialogWrapperComponent } from '@rtr-factory/ui/dialog';
import { RtrInputComponent, RtrInputErrors } from '@rtr-factory/ui/input';
import { whiteSpacesValidator } from 'rio-ui';

@Component({
  selector: 'app-add-organization-dialog',
  imports: [
    DialogWrapperComponent,
    TranslateModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    RtrButtonComponent,
    RtrInputComponent,
  ],
  templateUrl: './add-organization-dialog.component.html',
  styleUrl: './add-organization-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddOrganizationDialogComponent {
  dialogRef = inject(MatDialogRef);

  form = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(3), whiteSpacesValidator]),
    isInternal: new FormControl(false),
  });

  errors: RtrInputErrors = [
    {
      key: 'minlength',
      error: 'Validators.MinimumLength',
    },
    {
      key: 'required',
      error: 'Validators.Required',
    },
    {
      key: 'onlyWhitespacePresent',
      error: 'Validators.WhiteSpace',
    },
  ];

  confirm(): void {
    const { name, isInternal } = this.form.value;
    this.dialogRef.close({ name: name?.trim() ?? '', isInternal });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
